module.exports = __webpack_public_path__ + "static/media/SDG7.fe43bafe.mp4";